export default __webpack_public_path__ + "static/media/2412311.fbe04168.webp";